/**
 * Manuscript panel — chapter-by-chapter reader for the consolidated Invariant
 * Lifecycle Governance monograph, paired with the live witness validator through
 * the shared ChapterAppSplit layout.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import {
  ChapterAppSplit,
  createBuiltManuscriptViewerPanelFromFiles,
  deriveNumberOrAppendixId,
  deriveNumberOrAppendixTitle,
} from "@csk/demo-ui/components/manuscript-viewer";

const ValidatorPanel = React.lazy(async () => {
  const module = await import("./WitnessValidatorPanel.js");
  return { default: module.WitnessValidatorPanel };
});

const FILES = import.meta.glob<string>(
  [
    "../../../../../../theory/manuscripts/contrib/InvariantLifecycleGovernance/monograph/chapters/*.md",
    "!../../../../../../theory/manuscripts/contrib/InvariantLifecycleGovernance/monograph/chapters/README.md",
  ],
  { query: "?raw", import: "default", eager: true },
);

const ChapterPanel = createBuiltManuscriptViewerPanelFromFiles(
  {
    id: "ilg-monograph",
    label: "Manuscript",
    eyebrow: "INVARIANT LIFECYCLE GOVERNANCE · MONOGRAPH",
    deriveId: deriveNumberOrAppendixId,
    deriveTitle: deriveNumberOrAppendixTitle,
    isAppendix: (id: string): boolean => /^[A-Z]$/u.test(id),
  },
  FILES,
  {
    unavailablePath:
      "theory/manuscripts/contrib/InvariantLifecycleGovernance/monograph/chapters/.",
  },
);

export function ManuscriptPanel(): React.JSX.Element {
  return (
    <ChapterAppSplit
      chapterLabel="Manuscript"
      appLabel="Validator"
      chapterPanel={<ChapterPanel />}
      appPanel={
        <React.Suspense fallback={null}>
          <ValidatorPanel />
        </React.Suspense>
      }
      splitChapterFraction={0.56}
    />
  );
}
